/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import Helper from '../state/reducers/Helper';

/* eslint-disable react/jsx-props-no-spreading */
const ProtectedRoute = ({ component: Component, ...rest }) => {
    const { isAuthenticated } = Helper.getAuthentication();
    return (
        <Route
            {...rest}
            exact
            render={(props) => {
                if (!isAuthenticated) {
                    return <Redirect to="/auth/login" />;
                }
                return <Component {...props} />;
            }}
        />
    );
};

ProtectedRoute.propTypes = {
    component: PropTypes.func.isRequired,
};

export default ProtectedRoute;
